import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { ProgramsProvider } from './context/programsContext';
import { LangProvider } from './context/languageContext';
import { AuthProvider } from './context/AuthProvider';
import { SubscriptionsProvider } from './context/subscriptionsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LangProvider>
      <SubscriptionsProvider>
        <ProgramsProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ProgramsProvider>
      </SubscriptionsProvider>
    </LangProvider>
  </React.StrictMode>
);